<template>
  <div style="height: 100%;overflow: auto;">
    <el-button type="primary" round style="margin-bottom: 20px;" @click="recharge">立即充值</el-button>
    <el-table :data="list" border stripe>
      <el-table-column label="ID" prop="id" width="80px"></el-table-column>
      <el-table-column label="订单号" prop="order_no"></el-table-column>
      <el-table-column label="充值方式" prop="type"></el-table-column>
      <el-table-column label="支付金额" prop="money"></el-table-column>
      <el-table-column label="浏览次数" prop="look_num"></el-table-column>
      <el-table-column label="提交时间" prop="addtime"></el-table-column>
      <el-table-column label="支付状态" prop="">
        <template v-slot="scope">
          <el-tag type="success" size="small" v-if="scope.row.is_pay==1">已支付</el-tag>
          <el-tag type="info" size="small" v-if="scope.row.is_pay==0">未支付</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="支付时间" prop="pay_time"></el-table-column>
      <el-table-column label="操作" width="120px">
        <template v-slot="scope">
          <!--          <el-button type="primary" @click="admin_edit(scope.row.id)" size="small" style="margin-right: 10px;">编辑</el-button>-->
          <el-popconfirm title="确认删除？" @confirm="del(scope.row.id)">
            <el-button type="danger" size="small" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 60px;"></div>
    <layer-page :total="total" :page-size="20"></layer-page>
    <Layer-pop title="立即充值" @close="vue_pop_show_hide" v-if="is_pop">
      <div style="display: flex;flex-wrap: wrap;">
        <template v-for="(val,key) in setting">
          <div :class="key==select ? 'select item' : 'item'" v-bind:key="val" @click="toselect(key)">
            <div style="font-size: 26px;">充值{{ val.money }}</div>
            <div>送{{ val.look_num }}次</div>
          </div>
        </template>
      </div>
      <div style="margin: 50px auto;text-align: center;">
        <el-button type="primary" round @click="topay">立即充值</el-button>
      </div>
      <div class="bg" v-if="is_pay">
        <div class="box">
          <div class="mt-10">扫码支付</div>
          <img :src="pay_code" style="width: 100%;height: 100%">
          <span class="iconfont icon-close-circle" @click="pay_close"></span>
        </div>
      </div>
    </Layer-pop>
  </div>
</template>

<script>
import LayerPage from "@/components/layer-page";
import LayerPop from "@/components/layer-pop";

export default {
  name: "recharge",
  components:{LayerPage,LayerPop},
  data(){
    return{
      list:[],
      is_load:false,
      page:1,
      total:0,
      is_pop:false,
      select:0,
      setting:[],
      pay_no:'',
      pay_code:'',
      is_pay:false,
    }
  },
  mounted : async function(){
    try{
      await this.get_list();
    }catch (e){
      console.log(e);
      return false;
    }
  },
  methods: {
    get_setting:async function (){
      this.$_showLoading();
      let res =await this.$_api.setting('config',{type:'recharge'});
      this.$_hideLoading();
      if(res.errcode == 0){
        this.setting = this.user.is_vip==0 || this.user.is_end==1 ? res.data.content.recharge.normal :
            (this.user.is_vip==1 ?
            res.data.content.recharge.base : (this.user.is_vip==2 ? res.data.content.recharge.profession :
                    res.data.content.recharge.vip)) ;
      }
    },
    get_list: async function (){
      if(!this.is_load){
        this.is_load = true;
        this.$_showLoading();
        let res = await this.$_api.company('get_recharge_list', {page: this.page,uid:this.user.uid});
        this.is_load = false;
        this.$_hideLoading();
        this.list = res.list;
        this.total = res.total;
      }
    },
    recharge:function (){
      if(this.setting.length<=0){
        this.get_setting();
      }
      this.is_pop = true;
    },
    toselect:function (key){
      this.select = key;
    },
    topay:async function (){
      let that = this;
      let data = this.setting[this.select];
      data['uid'] = this.user.uid;
      this.$_showLoading();
      let res = await this.$_api.company('topay', data);
      this.$_hideLoading();
      if(res.errcode == 0){
        console.log(res);
        this.is_pay = true;
        this.pay_no = res.pay_no;
        this.pay_code = res.url;
        clearInterval(this.timer);
        this.timer = setInterval(async function (){
          let check = await that.$_api.company('check_pay', {pay_no : res.pay_no});
          if (check.errcode == 0) {
            clearInterval(that.timer);
            that.$_showToast(check.errmsg);
            that.$router.replace('/company_recharge');

          }
        },2000)
      }else{
        this.$_showToast(res.errmsg,res.style);
      }
    },
    pay_close:function (){
      this.is_pay = false;
    },
    del:async function (id){
      let that = this;
      that.$_showLoading();
      let res = await that.$_api.company('recharge_del', {id:id});
      that.$_hideLoading();
      if (res.errcode == 0) {
        that.$_showToast(res.errmsg);
        that.get_list();
      }
    },
  }
}
</script>

<style scoped>
.item{
  width: 48%;
  margin: 0 2% 20px 0;
  box-shadow: 0 0 5px #ccc;
  border-radius: 10px;
  padding: 40px 0;
  text-align: center;
}
.select{
  box-shadow: 0 0 5px #409eff;
}
.bg{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0,0,0,0.3);
  align-items: center;
  justify-content: center;
  justify-items: center;
}
.bg .box{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background: #fff;
  text-align: center;
}
.bg span{
  position: absolute;
  left: 50%;
  bottom: -100px;
  font-size: 40px;
  margin-left: -20px;
  color: #555;
  cursor: pointer;
}
</style>